// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"08d49d07","667":"ff286b70","977":"13ef505d"}[chunkId] + ".chunk.js";
};